import React from "react";
import { RotatingLines } from "react-loader-spinner";
import { tokens } from "../../theme/tokens";

type Props = {
  size?: number | string;
  className?: string;
  /**
   * What colour to draw in. Defaults to the brand green, which is right on the
   * dark surfaces this started on and WRONG on anything green: a primary Button
   * is a lime fill, so the default spinner was lime on lime and simply invisible.
   * A button that swapped its label to "Saving…" and showed nothing moving read
   * as stuck, which is the thing a spinner exists to prevent.
   */
  color?: string;
};

export default function Spinner({
  size = 80,
  className = "",
  color = tokens.primary,
}: Props) {
  return (
    <div className={`inline-flex items-center leading-none ${className}`}>
      {React.createElement(RotatingLines as any, {
        strokeColor: color,
        strokeWidth: "4",
        animationDuration: "0.8",
        width: String(size),
        visible: true,
      })}
    </div>
  );
}
